import { all, takeLatest, put, call } from 'redux-saga/effects';

import { apiVerifyDiscountCode } from '@dragonfruit/services/apis';
import { actions, types } from '@dragonfruit/redux/discountCode';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';
import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';
import { PURCHASE_DISCOUNT_CODE_APPLY_CLICK } from '@dragonfruit/constants/gtmEvents';

export function* applyDiscountCodeFlow(action) {
  const { discountCode, paymentMethodId, planId, planName } = action.payload;

  try {
    const response = yield call(apiVerifyDiscountCode, {
      paymentMethodId,
      code: discountCode,
    });
    const {
      data: { discountValue: discountAmount },
    } = response;
    yield put(actions.applyDiscountCodeSuccess(discountAmount));
    yield put(
      sendGtmEvent({
        eventName: PURCHASE_DISCOUNT_CODE_APPLY_CLICK,
        data: {
          planId,
          planName,
          isSuccess: true,
        },
      })
    );
  } catch (error) {
    yield put(actions.applyDiscountCodeFailure(error.message));
    yield put(
      sendGtmEvent({
        eventName: PURCHASE_DISCOUNT_CODE_APPLY_CLICK,
        data: {
          planId,
          planName,
          isSuccess: false,
        },
      })
    );
    yield put(
      showAlertBanner({
        message: error.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export default function*() {
  yield all([takeLatest(types.APPLY_DISCOUNT_CODE, applyDiscountCodeFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/discountCode.js